import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { UserShape, TackNotificationsShape, PeopleNotificationsShape, NavigationShape } from '../shapes';
import HeaderMenu from './header_menu';
import PropTypes from 'prop-types';

class Header extends React.Component {
  static propTypes = {
    navigation: NavigationShape,
    user: UserShape,
    tackNotifications: TackNotificationsShape,
    peopleNotifications: PeopleNotificationsShape,
    onLogout: PropTypes.func,
    location: PropTypes.object // Added by withRouter
  }

  render() {
    return(
      <header className='row'>
        { this.renderLogo() }
        { this.renderUser() }
      </header>
    );
  }

  renderUser() {
    if (this.props.user.get('loggedIn')) {
      return (
        <span className='login-area'>
          <span className='hidden-on-mobile'>
            Hello, { this.props.user.get('email') }
            <span className='dot-spacer'></span>
          </span>
          <Link to= {'/tack_board' }>
            <span className='board-link'><b>tack board</b></span>
          </Link>
          { this.renderUnreadTackNotificationCount() }
          <span className='dot-spacer'></span>
          <Link to= {'/people_board' }>
            <span className='board-link'><b>people board</b></span>
          </Link>
          { this.renderUnreadPeopleNotificationCount() }
          <span className='dot-spacer'></span>
          <HeaderMenu user={ this.props.user } tackNotifications={ this.props.tackNotifications } onLogout={ this.props.onLogout } />
        </span>
      )
    } else {
      return (
        <span className='login-area'>
          <Link className='login' to={ '/account/login' }>log in</Link>
          <span className='dot-spacer'></span>
          <Link className='login' to={ '/account/create' }>sign up</Link>
        </span>
      );
    }
  }

  renderLogo() {
    // Don't render logo if we're on the homepage
    // Use React Router's location instead of our custom navigation state
    const pathname = this.props.location.pathname;

    // Hide logo on homepage
    if (pathname === '/') {
      return null;
    }

    return (
      <span className='logo-area' style={{ marginTop: '10px' }}>
        <Link to={'/'}>
          <img src={'https://yaktack-prod-images.s3.us-west-2.amazonaws.com/yak-tack-logo-papercraft-100.png'} className="logo" alt="yak tack" />
        </Link>
      </span>
    );
  }

  renderUnreadTackNotificationCount() {
    if (this.props.tackNotifications.get('unreadCount') > 0) {
      return (
        <span className='unread-notification badge badge-pill badge-danger'>{ this.props.tackNotifications.get('unreadCount') }</span>
      );
    } else return null;
  }

  renderUnreadPeopleNotificationCount() {
    if (this.props.peopleNotifications.get('unreadCount') > 0) {
      return (
        <span className='unread-notification badge badge-pill badge-danger'>{ this.props.peopleNotifications.get('unreadCount') }</span>
      );
    } else return null;
  }
}

export default withRouter(Header);



// WEBPACK FOOTER //
// ./src/components/header.jsx